import React from 'react';
import { useEditorContext } from '../../../../components/Editor/Context';
import cn from 'classnames';
import Alignment from '../buttons/Alignment';
import Delete from '../buttons/Delete';
import Settings from '../buttons/Settings/Settings';
import BlockBubbleMenu from '../../../../components/menus/BlockBubbleMenu';
import { getExtensionOptions, shouldBlockMenuBeOpen } from '../../../../components/utils/tiptap';
import { isTouch } from '../../../../components/utils/browser';
import { EXTENSION_TYPE_NAME } from '../../constants';
import Convert from '../buttons/Convert';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Link from '../buttons/Link';
const MenuButtons = ({ editor, forMobile = false })=>{
    const options = getExtensionOptions(editor, EXTENSION_TYPE_NAME);
    const isEditorInline = useFlag('editor_inline');
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(!forMobile && 'ds-surface-tertiary'),
        style: {
            maxWidth: '100vw',
            display: 'flex',
            flexWrap: 'wrap'
        }
    }, /*#__PURE__*/ React.createElement(Alignment, {
        editor: editor
    }), options.standaloneLink && /*#__PURE__*/ React.createElement(Link, {
        editor: editor
    }), options.canConfigure && /*#__PURE__*/ React.createElement(Settings, {
        editor: editor
    }), /*#__PURE__*/ React.createElement(Delete, {
        editor: editor
    }), isEditorInline && /*#__PURE__*/ React.createElement(Convert, {
        editor: editor
    }));
};
const DaDeviationBubbleMenu = ({ scrollContainerRef })=>{
    const editor = useEditorContext();
    const isEditorInline = useFlag('editor_inline');
    if (!editor) {
        return null;
    }
    if (!(editor === null || editor === void 0 ? void 0 : editor.isEditable) || isTouch()) {
        return null;
    }
    const open = shouldBlockMenuBeOpen(editor, EXTENSION_TYPE_NAME);
    const options = getExtensionOptions(editor, EXTENSION_TYPE_NAME);
    let buttonCount = 3;
    if (!options.canAlign) {
        buttonCount--;
    }
    if (!options.canConfigure) {
        buttonCount--;
    }
    if (isEditorInline) {
        buttonCount++;
    }
    if (options.standaloneLink) {
        buttonCount++;
    }
    return /*#__PURE__*/ React.createElement(BlockBubbleMenu, {
        scrollContainerRef: scrollContainerRef,
        menuHeight: 34,
        menuWidth: 32 * buttonCount,
        editor: editor,
        open: open,
        childSelector: "figure"
    }, /*#__PURE__*/ React.createElement(MenuButtons, {
        editor: editor
    }));
};
DaDeviationBubbleMenu.displayName = 'DaDeviationBubbleMenu';
export default DaDeviationBubbleMenu;
export { MenuButtons };

//# sourceMappingURL=DaDeviationBubbleMenu.js.map